import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { store } from './v1/store/store'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import router from "./router";
import Modal from 'react-modal';
import { useFavicon } from "./v1/hooks/useFavicon";
import * as Sentry from "@sentry/react";


Sentry.init({
  dsn: "https://b695b7db08d7b966843dc6cf543fe70c@o4509684467433472.ingest.us.sentry.io/4509684471496704",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});
// Set the app element for react-modal
Modal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById("root"));

// Root wrapper to use hooks
function RootApp() {
  useFavicon(); // <-- applies favicon based on theme

  return <RouterProvider router={router} />;
}

root.render(
  <Provider store={store}>
    <RootApp />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
